// project import
import Routes from 'routes';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AppName } from 'utils/constants';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //
import './main.css';
const App = () => {
  const location = useLocation();

  useEffect(() => {
    // Define a mapping of route paths to page titles
    const routeToTitleMap = {
      '/': `${AppName}`,
      '/404': `Page Not Found | ${AppName}`,
      '/salesorder': `Sales Order | ${AppName}`,
      '/sales-performer': `Sales Order Performa | ${AppName}`,
      '/sales-performer-report': `Sales Order Performa Report | ${AppName}`,
      '/dashboard': `Dashboard | ${AppName}`,
      '/barcodeSO': `Barcode Scanner Fabric | ${AppName}`,
      '/barcodeSOg': `Barcode Scanner Garment | ${AppName}`,
      '/stockselectionf': `Stock Selection Fabric | ${AppName}`,
      '/stockselectiong': `Stock Selection Garment | ${AppName}`,
      '/productBookingf': `Product Booking Fabric | ${AppName}`,
      '/productBookingg': `Product Booking Garment | ${AppName}`,
      '/deliveryschedulef': `Delivery Schedule Fabric | ${AppName}`,
      '/deliveryscheduleg': `Delivery Schedule Garment | ${AppName}`,
      '/saleorderdetails': `Order Details Garment| ${AppName}`,
      '/saleorderdetailsf': `Order Details Fabric | ${AppName}`,
      '/deliveryconfirmation': `Delivery Confirmation | ${AppName}`,
      '/barcodedashboard': `Barcode Dashboard | ${AppName}`,
      '/attedancereport': `Attendance Report | ${AppName}`,
      '/myordersreport': `My Orders Report | ${AppName}`,
      '/customerProfile': `Customer Profile | ${AppName}`,
      '/check-barcode-for-stock': `Check Barcode Stock | ${AppName}`,
      '/samplecheck': `Sample Check Garment| ${AppName}`,
      '/samplecheckf': `Sample Check Fabric | ${AppName}`,
      '/ledger': `Ledger Report | ${AppName}`,
      '/seoreport': `SEO Report | ${AppName}`,
      '/stockdownload': `Stock Download | ${AppName}`,
      '/stockupload': `Stock Upload | ${AppName}`,
      '/salesOrderUpload': `Sales Order Upload | ${AppName}`,
      '/login': `Login | ${AppName}`,
      '/forgotpass': `Forgot Password | ${AppName}`,
      '/otpverify': `Verify OTP | ${AppName}`,
      '/reset-password': `Reset Password | ${AppName}`,
      '/ledgerCurrentYear': `Ledger Current Year | ${AppName}`,
      '/ledgerDiv': `Division Wise Ledger | ${AppName}`,
      '/ledgerCurrentYearDetails': `Ledger Detail | ${AppName}`,
      '/ledgerDivDetails': `Ledger Detail | ${AppName}`,
      '/ledgerPreviousYear': `Ledger Previous Year | ${AppName}`,
      '/ledgerpreviousYear': `Ledger Previous Year | ${AppName}`,
      '/ptFile': `PT File | ${AppName}`,
      '/vendorLedger': `Vendor Ledger | ${AppName}`,
      '/vendorledgerDetails': `Vendor Ledger Detail | ${AppName}`,
      '/passessment': `Product Assessment | ${AppName}`,
      '/divoutstanding': `Division Wise Outstanding | ${AppName}`,
      '/divoutstandingnew': `Division Wise Outstanding | ${AppName}`,
      '/assessment-reports': `Assessment Reports | ${AppName}`,
      '/ledgerPreviousYearDetails': `Ledger Detail | ${AppName}`,
      '/beats': `BEATS | ${AppName}`,
      '/beat-customers': `BEATS Customers | ${AppName}`,
      '/beat-customer-reports': `BEATS Customer Reports | ${AppName}`,
      '/beat-planning': `BEATS Planning | ${AppName}`,
      '/distributorkpi-reports': `KPI Reports | ${AppName}`,
      '/market-intelligence': `Market Intelligence | ${AppName}`,
      '/product-catalogue': `Product Catalogue | ${AppName}`,
      '/user-reports': `User Reports | ${AppName}`,

      // goods return
      '/good-returns-list': `Good Returns List | ${AppName}`,
      '/good-returns': `Good Returns | ${AppName}`,
      '/good-returns-transfer': `Good Returns Transfer | ${AppName}`,

      // SFA User Fabric Sales Order
      '/sfa-stockselectionf': `SFA Stock Selection Fabric | ${AppName}`,
      '/sfa-productBookingf': `SFA Product Booking Fabric | ${AppName}`,
      '/sfa-deliveryschedulef': `SFA Delivery Schedule Fabric | ${AppName}`,

      // Sample Request Module
      '/view-sample-request': `Sample Request Report | ${AppName}`,
      '/sample-request-dashboard': `Sample Request Dashboard | ${AppName}`,
      '/tour-expense-claim': `Tour Expense Claim | ${AppName}`,
      '/display-and-events': `Display and Events | ${AppName}`,
      '/sample-design': `Sample Design | ${AppName}`,
      '/sample-request-barcode-scan': `Sample Request Barcode Scan | ${AppName}`,
      '/sample-request-selection': `Sample Request Selection | ${AppName}`,
      '/denkint-sample_process': `Denkint Sample Process | ${AppName}`,
      '/denkint-sample_process/add': `Add Sample Process | ${AppName}`,
      '/denkint-sample_process/barcode-dashboard': `Denkint Barcode Dashboard | ${AppName}`,
      '/denkint-sample_process/barcode-scan': `Denkint Barcode Scanner | ${AppName}`,
      '/denkint-sample_process/fabric-selection': `Denkint Fabric Selection | ${AppName}`,
      '/denkint-sample_process/garment-selection': `Denkint Garment Selection | ${AppName}`,
      '/denkint-sample_process/fabric-product-booking': `Denkint Fabric Stock Booking | ${AppName}`,
      '/denkint-sample_process/garment-product-booking': `Denkint Garment Stock Booking | ${AppName}`,
      '/denkint-sample_process/fabric-checkout': `Denkint Fabric Checkout | ${AppName}`,
      '/denkint-sample_process/garment-checkout': `Denkint Garment Checkout | ${AppName}`,

      //sample request 90 days module
      '/sample-design-sales-planning': `Sample Design Sales Planning | ${AppName}`,
      '/barcode-scan-sales-planning': `Barcode Scan Sales Planning | ${AppName}`,
      '/dashboard-sales-planning': `Sales Planning Dashboard | ${AppName}`,
      '/sample-selection-sales-planning': `Sample Selection Sales Planning | ${AppName}`,

      //reports
      '/pending-order-reports': `Pending Order Reports | ${AppName}`,
      '/outstanding-reports': `Outstanding Reports | ${AppName}`,
      '/collection-recieved': `Collection Recieved | ${AppName}`,
      '/scheme-report': `Scheme Report | ${AppName}`,
      '/report-dashboard': `Report Dashboard | ${AppName}`,
      '/collection-target-achv-report': `Collection Target Achv Report | ${AppName}`,
      '/current-month-sales-report': `Current Month Sales Figure | ${AppName}`,
      '/agency-performance-report': `Agency Performance | ${AppName}`,
      '/non-billed-reports': `NON BILLED REPORT | ${AppName}`,


      
    };

    // Get the current path
    const currentPath = location.pathname;

    // Update the document title based on the current route
    document.title = routeToTitleMap[currentPath] || 'Default Title';
  }, [location.pathname]);

  return (
    <React.StrictMode>
      <ThemeCustomization>
        <ScrollTop>
          <Routes />
        </ScrollTop>
      </ThemeCustomization>
    </React.StrictMode>
  );
};

export default App;
